import { render, staticRenderFns } from "./AiMessageBubble.vue?vue&type=template&id=13ae837a&scoped=true&"
import script from "./AiMessageBubble.vue?vue&type=script&lang=js&"
export * from "./AiMessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./AiMessageBubble.vue?vue&type=style&index=0&id=13ae837a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae837a",
  null
  
)

export default component.exports